module.exports = __webpack_public_path__ + "static/media/15.9a10c202.jpg";